/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

:host {
  display: inline-block;
  inline-size: auto;
  overflow: visible;
  border-radius: 0px;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-1);
  vertical-align: top;
}

:host([scale=s]) {
  inline-size: 234px;
  min-inline-size: 216px;
  max-inline-size: 380px;
}

:host([scale=m]) {
  inline-size: 304px;
  min-inline-size: 272px;
  max-inline-size: 480px;
}

:host([scale=l]) {
  inline-size: 370px;
  min-inline-size: 320px;
  max-inline-size: 600px;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}